import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  PreferenceTagModel,
  PreferenceTagMutationInput,
  PreferenceTagDeleteInput,
  PreferenceTagUpdateInput,
} from './model';

export function useCreatePreferenceTag(
  options?: UseMutationOptions<
    ApiResult<PreferenceTagModel>,
    ApiError,
    PreferenceTagMutationInput
  >,
): UseMutationResult<
  ApiResult<PreferenceTagModel>,
  ApiError,
  PreferenceTagMutationInput
> {
  return useMutation<
    ApiResult<PreferenceTagModel>,
    ApiError,
    PreferenceTagMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'preference-groups',
      method: 'POST',
      classType: PreferenceTagModel,
      body,
    });
  }, options);
}

export function useUpdatePreferenceTag(
  options?: UseMutationOptions<
    ApiResult<PreferenceTagModel>,
    ApiError,
    PreferenceTagUpdateInput
  >,
): UseMutationResult<
  ApiResult<PreferenceTagModel>,
  ApiError,
  PreferenceTagUpdateInput
> {
  return useMutation<
    ApiResult<PreferenceTagModel>,
    ApiError,
    PreferenceTagUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `preference-groups/${body.preferenceTagId}`,
      method: 'PUT',
      classType: PreferenceTagModel,
      body: body.body,
    });
  }, options);
}

export function useDeletePreferenceTag(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    PreferenceTagDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, PreferenceTagDeleteInput> {
  return useMutation<{ message: string }, ApiError, PreferenceTagDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `preference-groups/${body.preferenceTagId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
